export const CHANGE_USER_INFO = 'CHANGE_USER_INFO';
export const CHANGE_SYSTEM_DATE = 'CHANGE_SYSTEM_DATE';
export const CHANGE_LOGIN_STATUS = 'CHANGE_LOGIN_STATUS';